enum BillingTypes {
  CancelRequest = 'billing.CancelRequest',
  CancelSuccess = 'billing.CancelSuccess',
  CancelFailure = 'billing.CancelFailure',
  GetInvoicesRequest = 'billing.getInvoicesRequest',
  GetInvoicesSuccess = 'billing.getInvoicesSuccess',
  GetInvoicesFailure = 'billing.getInvoicesFailure',
  GetPaymentInfoRequest = 'billing.getPaymentInfoRequest',
  GetPaymentInfoSuccess = 'billing.getPaymentInfoSuccess',
  GetPaymentInfoFailure = 'billing.getPaymentInfoFailure',
  SavePaymentInfoRequest = 'billing.savePaymentInfoRequest',
  SavePaymentInfoSuccess = 'billing.savePaymentInfoSuccess',
  SavePaymentInfoFailure = 'billing.savePaymentInfoFailure',
  UpdateBillingEmailRequest = 'billing.updateBillingEmailRequest',
  UpdateBillingEmailSuccess = 'billing.updateBillingEmailSuccess',
  UpdateBillingEmailFailure = 'billing.updateBillingEmailFailure',
  UpdateInvoiceInfoRequest = 'billing.updateInvoiceInfoRequest',
  UpdateInvoiceInfoSuccess = 'billing.updateInvoiceInfoSuccess',
  UpdateInvoiceInfoFailure = 'billing.updateInvoiceInfoFailure',
}

export { BillingTypes };
